import Vue from 'vue'
import VueRouter from 'vue-router'

import Sidebar from '../components/includes/Sidebar.vue'
import settings from '../modules/settings.js'

import listRepresentation from '../views/listRepresentation.vue'
import editRepresentation from '../views/editRepresentation.vue'
import payRepresentation from '../views/payRepresentation.vue'
import listSalonOwner from '../views/listSalonOwner.vue'
import entryAndEditListSalonOwner from '../views/entryAndEditListSalonOwner.vue'
import paySalonOwner from '../views/paySalonOwner.vue'
import listSalonsOwner from '../views/listSalonsOwner.vue'
import editEntrySalon from '../views/editEntrySalon.vue'
import mapLocation from '../views/mapLocation'
import playerDescription from '../views/playerDescription'
import managementTodaySalon from '../views/managementTodaySalon'
import login from '../views/login'
import managementCommissionAndGender from '../views/managementCommissionAndGender'
import commentSalons from '../views/commentSalons'
import descriptionDayReservation from '../views/descriptionDayReservation'
import listPlayer from '../views/listPlayer'
import walletPlayer from '../views/walletPlayer'
import listCups from '../views/listCups'
import entryAndEditListCup from '../views/entryAndEditListCup'
import gameFuture from '../views/gameFuture'
import Team from '../views/Team'
import editTeam from '../views/editTeam'
import teamPlayer from '../views/teamPlayer'
import entryAndEditListGameFuture from '../views/entryAndEditListGameFuture'
import tabScorersAndKnockoutAndGroup from '../views/tabScorersAndKnockoutAndGroup'
import entryAndEditListTabScorersAndKnockoutAndGroup from '../views/entryAndEditListTabScorersAndKnockoutAndGroup'
import listSalons from '../views/listSalons'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: { pageTitle: '', requiredAuth: false }
  },
  {
    path: '/representation',
    name: 'listRepresentation',
    component: listRepresentation,
    meta: { pageTitle: 'لیست نمایندگی ها', requiredAuth: true }
  },
  {
    path: '/edit-representation/:id',
    name: 'editRepresentation',
    component: editRepresentation,
    meta: { pageTitle: 'ثبت و ویرایش نمایندگی', requiredAuth: true }
  },
  {
    path: '/pay-representation',
    name: 'payRepresentation',
    component: payRepresentation,
    meta: { pageTitle: 'پرداخت های سیستم به نمایندگان', requiredAuth: true }
  },
  {
    path: '/list-salon-owner',
    name: 'listSalonOwner',
    component: listSalonOwner,
    meta: { pageTitle: 'لیست سالنداران', requiredAuth: true }
  },
  {
    path: '/entry-list-salon-owner',
    name: 'entryListSalonOwner',
    component: entryAndEditListSalonOwner,
    meta: { pageTitle: 'ثبت/ویرایش سالندار', requiredAuth: true }
  },
  {
    path: '/edit-list-salon-owner/:id',
    name: 'editListSalonOwnerSingle',
    component: entryAndEditListSalonOwner,
    meta: { pageTitle: 'ثبت/ویرایش سالندار', requiredAuth: true }
  },
  {
    path: '/pay-salon-owner',
    name: 'paySalonOwner',
    component: paySalonOwner,
    meta: { pageTitle: 'پرداخت سیستم به سالن ها', requiredAuth: true }
  },
  {
    path: '/salons',
    name: 'salons',
    component: listSalons,
    meta: { pageTitle: 'لیست کل سالن ها', requiredAuth: true }
  },
  {
    path: '/list-salon-owners/:id',
    name: 'listSalonsOwner',
    component: listSalonsOwner,
    meta: { pageTitle: 'لیست سالن ها', requiredAuth: true }
  },
  {
    path: '/list-salon-owners/salon-edit/:id',
    name: 'addSalon',
    component: editEntrySalon,
    meta: { pageTitle: 'ثبت/ویرایش سالن', requiredAuth: true }
  },
  {
    path: '/salon-add',
    name: 'editSalon',
    component: editEntrySalon,
    meta: { pageTitle: 'ثبت/ویرایش سالن', requiredAuth: true }
  },
  {
    path: '/salon-map',
    name: 'mapLocation',
    component: mapLocation,
    meta: { pageTitle: 'ثبت/ویرایش موقعیت مکانی', requiredAuth: true }
  },
  {
    path: '/player-description',
    name: 'playerDescription',
    component: playerDescription,
    meta: { pageTitle: 'توضیحات نیاز به بازیکن', requiredAuth: true }
  },
  {
    path: '/management-today-salon/:id',
    name: 'managementTodaySalon',
    component: managementTodaySalon,
    meta: { pageTitle: 'مدیریت سانس های روز ', requiredAuth: true }
  },
  {
    path: '/management-commission/:id',
    name: 'managementCommissionAndGender',
    component: managementCommissionAndGender,
    meta: { pageTitle: 'مدیریت پورسانت و جنسیت', requiredAuth: true }
  },
  {
    path: '/comment-salons',
    name: 'commentSalons',
    component: commentSalons,
    meta: { pageTitle: 'نظرات سالنها', requiredAuth: true }
  },
  {
    path: '/description-day-reservation',
    name: 'descriptionDayReservation',
    component: descriptionDayReservation,
    meta: { pageTitle: 'توضیحات رزروهای دنگی', requiredAuth: true }
  },
  {
    path: '/list-player',
    name: 'listPlayer',
    component: listPlayer,
    meta: { pageTitle: 'لیست بازیکنان', requiredAuth: true }
  },
  {
    path: '/wallet-player/:id',
    name: 'walletPlayer',
    component: walletPlayer,
    meta: { pageTitle: 'گردش کیف پول بازیکن', requiredAuth: true }
  },
  {
    path: '/list-cups',
    name: 'listCups',
    component: listCups,
    meta: { pageTitle: 'لیست جام ها', requiredAuth: true }
  },
  {
    path: '/edit-list-cup/:id',
    name: 'entryAndEditListCup',
    component: entryAndEditListCup,
    meta: { pageTitle: 'ثبت/ویرایش جام', requiredAuth: true }
  },
  {
    path: '/add-cup',
    name: 'addCup',
    component: entryAndEditListCup,
    meta: { pageTitle: 'ثبت/ویرایش جام', requiredAuth: true }
  },
  {
    path: '/tems/:cup_id/:state_active_tab',
    name: 'Team',
    component: Team,
    meta: { pageTitle: 'تیم ها ', requiredAuth: true }
  },
  {
    path: '/edit-team/:id',
    name: 'editTeam',
    component: editTeam,
    meta: { pageTitle: 'ویرایش تیم', requiredAuth: true }
  },
  {
    path: '/team-player/:id',
    name: 'teamPlayer',
    component: teamPlayer,
    meta: { pageTitle: 'لیست بازیکنان تیم', requiredAuth: true }
  },
  {
    path: '/game-future/:cup_id/:state_match_check_future_passed',
    name: 'gameFuture',
    component: gameFuture,
    meta: { pageTitle: 'بازی های آینده', requiredAuth: true }
  },
  {
    path: '/game-future-edit/:id',
    name: 'editGameFuture',
    component: entryAndEditListGameFuture,
    meta: { pageTitle: 'ویرایش بازی های آینده', requiredAuth: true }
  },
  {
    path: '/game-future-add/:cup_id',
    name: 'addGameFuture',
    component: entryAndEditListGameFuture,
    meta: { pageTitle: 'اضافه کردن بازی آینده', requiredAuth: true }
  },
  {
    path: '/tab-games/:cup_id/:state_active_tab',
    name: 'tabScorersAndKnockoutAndGroup',
    component: tabScorersAndKnockoutAndGroup,
    meta: { pageTitle: 'جدول حذفی', requiredAuth: true }
  },
  {
    path: '/tab-games-edit/:id',
    name: 'entryAndEditListTabScorersAndKnockoutAndGroup',
    component: entryAndEditListTabScorersAndKnockoutAndGroup,
    meta: { pageTitle: 'ویرایش', requiredAuth: true }
  },
  {
    path: '/tab-games-add/:cup_id/:state_active_tab',
    name: 'entryTabScorersAndKnockoutAndGroup',
    component: entryAndEditListTabScorersAndKnockoutAndGroup,
    meta: { pageTitle: 'اضافه کردن', requiredAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // store.commit('updateShowSidebar', false)
  window.dispatchEvent(new Event('resize'))

  const token = settings.get('authorization')
  const needToken = to.meta.requiredAuth

  if (!token && needToken) {
    next({
      name: 'login'
    })
  }

  if (typeof (needToken) === 'undefined') {
    next({
      name: 'login'
    })
  }

  next()
})

export default router
